module.exports = __webpack_public_path__ + "img/submit.f96ec3ca.png";